// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-0793ec8f] {\n  width: calc(100% - 40px);\n  margin: 0 auto;\n}\n.content .form[data-v-0793ec8f] {\n  display: flex;\n}\n.content .form .el-form-item + .el-form-item[data-v-0793ec8f] {\n  margin-left: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
